<template>
  <div id="app">
    <router-view></router-view>
    <div class="answer_fixed" v-if="isShow||telShow">
      <div class="bookOrdering" @click="goToBookOrdering" v-if="isShow">
        <img src="@/assets/common/book-ordering.png" alt="">
      </div>
      <div class="tel_box" @click="show=true" v-if="telShow">
        <div class="img_box">
          <img src="@/assets/common/ico-tel.png" alt="" srcset="" class="tel_img">
          <span>订购咨询</span>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round  :close-on-click-overlay="false">
      <div class="popup_box">
        <div class="img_box" @click="show=false">
          <img src="@/assets/common/guanbi-icon.png" class="close_img" />
        </div>
        <div class="title">订购咨询电话：</div>
        <div class="tel_list_box">
          <div class="tel_list">010-68036672</div>
          <div class="tel_list">010-68021338</div>
          <div class="tel_list">010-68032104</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    this.tokenTime()
  },
  data() {
    return {
      isShow:true,
      show:false,
      telShow:true
    }
  },
  watch: {
    $route() {
      console.log(this.$route.query.orderType,'22')
      this.isShow = this.$route.meta.bookShow ? true : false
      this.telShow = this.$route.meta.telShow ? true : false
      if(this.$route.path == '/detail'&&this.$route.query.orderType != 'ordering'){
        this.telShow = false
      }
    }
  },
  mounted(){
    console.log(this.$route.path,'aa')
    this.isShow = this.$route.meta.bookShow ? true : false
    this.telShow = this.$route.meta.telShow ? true : false
    if(this.$route.path == '/detail'&&this.$route.query.orderType != 'ordering'){
      this.telShow = false
    }
    if(!localStorage.getItem('openId')){
      this.getCode()
    }
    
    let ua = window.navigator.userAgent.toLowerCase()
    if(ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.wxShare()
    }
    window.onload = function() {
     document.addEventListener('touchstart', function(event) {
       if (event.touches.length > 1) {
         event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function(event) {
       event.preventDefault()
      })
    }
  },
  methods:{
    goToBookOrdering(){
      this.$router.push({path:'/bookOrderingList'})
    },
    // 获取code
			// 先判断url中有没有code，如果有code，表明已经授权，如果没有code，跳转微信授权链接
			getCode() {
				let ua = window.navigator.userAgent.toLowerCase()
				if((ua.match(/MicroMessenger/i) == 'micromessenger')) {
					console.log(ua,'微信浏览器')
					// 截取地址中的code，如果没有code就去微信授权，如果已经获取到code了就直接把code传给后台获取openId
					let code = this.getUrlCode('code')
					console.log(code,'获取code')
					if (!code) {
						if(window.location.hash!="#/"){
							sessionStorage.setItem("path",window.location.href)
						}
						window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ this.$appid +'&redirect_uri=' + this.$local + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
						// redirect_uri是授权成功后，跳转的url地址，微信会帮我们跳转到该链接，并且通过？的形式拼接code，这里需要用encodeURIComponent对链接进行处理。
						// 如果配置参数一一对应，那么此时已经通过回调地址刷新页面后，你就会再地址栏中看到code了。
					}
				}
			},
      getUrlCode(name) {
				return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
			},
      tokenTime(){
        let tokentime = localStorage.getItem('tokentime') //过期时间
        let newtime = Date.parse(new Date())
        if(tokentime == '' || tokentime == undefined){
          localStorage.removeItem('y-token')
          return false
        }
        if(newtime > tokentime){
          localStorage.removeItem('y-token')
        }
      },
  }
}
</script>

<style lang="scss">
.popup_box{
  width: 5.60rem;
  height: 2.92rem;
  background: #FFFFFF;
  border-radius: .20rem;
  position: relative;
  box-sizing: border-box;
  padding: .61rem .58rem 0;
  .title{
    font-size: .32rem;
    font-weight: bold;
    color: #000000;
  }
  .tel_list_box{
    width: 100%;
    margin-top: .32rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: .28rem;
    font-weight: 500;
    color: #EF2E15;
    line-height: .48rem;
  }
  .img_box{
    position: absolute;
    width: .5rem;
    height: .5rem;
    right: .16rem;
    top: .16rem;
  }
  .close_img{
    width: .32rem;
    height: .32rem;
    position: absolute;
    right: .1rem;
    top: .1rem;
  }
}
.tel_box{
  width: 1.08rem;
  height: 1.17rem;
  background: #FFFFFF;
  border: 0.02rem solid #FFBA00;
  border-radius: .10rem;
  cursor: pointer;
  position: relative;
  margin-top: .28rem;
  .img_box{
    width: 1.05rem;
    height: 1.15rem;
    background: linear-gradient(0deg, #F34D37 0%, #F34E36 100%);
    border-radius: .1rem;
    position: absolute;
    left: -0.02rem;
    top: -0.02rem;
    z-index: 2;
    .tel_img{
      position: absolute;
      width: .54rem;
      height: .54rem;
      left: 50%;
      transform: translateX(-50%);
      top: .17rem;
    }
    span{
      font-weight: 600;
      font-size: .2rem;
      color: #FFFFFF;
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      top: .74rem;
      white-space: nowrap;
    }
  }
}
body  
  {  
      -webkit-text-size-adjust: 100% !important;  
      text-size-adjust: 100% !important;  
      -moz-text-size-adjust: 100% !important;  
      min-height: 100%;
  }  
  html{
    height: 100%;
  }
img{
  object-fit: cover;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50;
  -moz-user-select: none; 
  -webkit-user-select: none; 
  -ms-user-select: none; 
  -khtml-user-select: none; 
  user-select: none;
}
a{
  text-decoration: none;
}
ul,li{
  list-style: none!important;
}
p {
  margin: 0;
  padding: 0;
}
.answer_fixed {
  width: 1.12rem;
  position: fixed;
  right: .4rem;
  bottom: 1.4rem;
  z-index: 200;
}
.bookOrdering{
  width: 1.1rem;
}
.bookOrdering img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue